import { render, staticRenderFns } from "./CardDashboardSkeleton.vue?vue&type=template&id=e8b55c68&scoped=true"
import script from "./CardDashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardDashboardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardDashboardSkeleton.vue?vue&type=style&index=0&id=e8b55c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b55c68",
  null
  
)

export default component.exports